import { useAuthStore } from '@/modules/auth/store/auth';
import { storeToRefs } from 'pinia';

export default defineNuxtRouteMiddleware(async (to) => {
  const { data, getSession } = useAuth();

  if (!data.value) {
    await getSession();
  }

  const accountType = (data.value as any)?.data?.account_type;

  if (accountType !== 'Merchant') {
    return navigateTo('/');
  }

  // Sync Pinia store so page components have access
  const authStore = useAuthStore();
  const { user } = storeToRefs(authStore);
  if ((data.value as any)?.data) {
    user.value = (data.value as any).data;
  }
});
